import { useState, useEffect, useCallback } from "react";
import Validation from "./validation";
import { RegistrationEntry, CreateEntry, UpdateEntry, GetOne } from '../../providers/dataProvider';
import { CheckNull } from "../../utils/Validate";
import { useLocation, useNavigate, useRouteError } from "react-router-dom";
import { ErrorMessages, SuccessMessages } from '../../constants/MessageConstants';
import { ValidateMessages } from '../../constants/ValidateConstants';

const useForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [formValues, setFormValues] = useState({
    userName: "",
    userType: 0,
    userCompanyId: "",
    firstName: "",
    lastName: "",
    phone: "",
    designationId: 0,
    departmentId: 0,
    password: "",
    confirmPassword: "",
    roleId: "",
    reportingTo: "",
    profileImage: "",
    specialPermissions: "",
    loginDisabled: "",
    isActive: "",
    canViewCostingOverride: false,
    createdBy: localStorage.getItem("authidentity")
  });

  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [createMsg, setCreateMsg] = useState(null)
  const [show, setShow] = useState(false);
  const [userType, setUserType] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [departmentName, setDepartmentName] = useState(null);
  const [designationName, setDesignationName] = useState(null);
  const [UserRoleName, setUserRoleName] = useState(null);
  const [UserReportingName, setUserReportingName] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [checkedPermissions, setCheckedPermissions] = useState([]);
  const [userTypedrp] = useState([
    { "value": "1", "label": "Employee" },
    { "value": "2", "label": "Distributor" }]);
  const [editUserDetails, seteditUserDetails] = useState(null);
  const [listdata, setListData] = useState({ data: {} });
  const [loading, setLoading] = useState(Boolean(location?.state?.id));

  function handleToggleChange() {
    const newValue = !isChecked;
    setIsChecked(newValue);
    setFormValues({ ...formValues, loginDisabled: newValue });
  }

  const handlePermissionType = (e) => {
    const { checked, id } = e.target;
    let newPermissions = [];
    if (checked) { newPermissions = [...checkedPermissions, id] } else {
      newPermissions = checkedPermissions.filter((permission) => permission !== id)
    }
    setCheckedPermissions(newPermissions);
    setFormValues({ ...formValues, specialPermissions: newPermissions.join(",") });
  };

  const handleCostingPermission = (e) => {
    const value = e.target.checked;
    setFormValues((prev) => ({
      ...prev,
      canViewCostingOverride: value,
    }));
  };

  const handleUserTypeChange = (selectedOption) => {
    setUserType(selectedOption);
    setFormValues({ ...formValues, userType: selectedOption.value, userCompanyId: '', roleId: "" });
    setFormErrors({ ...formErrors, userType: !selectedOption })
    setUserRoleName(null);
    setCompanyName(null);
  };

  const handleCompanyChange = (selectedOption) => {
    setCompanyName(selectedOption);
    setFormValues({
      ...formValues,
      userCompanyId: selectedOption.value,
    });
    setFormErrors({
      ...formErrors,
      userCompanyId: !selectedOption
    });
  };

  const handleDepartmentChange = (selectedOption) => {
    setDepartmentName(selectedOption);
    setFormValues({
      ...formValues,
      departmentId: selectedOption.value,
    });
    setFormErrors({
      ...formErrors,
      departmentId: !selectedOption
    })
  };

  const handleDesignationChange = (selectedOption) => {
    setDesignationName(selectedOption);
    setFormValues({
      ...formValues,
      designationId: selectedOption.value,
    });
    setFormErrors({
      ...formErrors,
      designationId: !selectedOption
    });
  }

  const handleUserRoleChange = (selectedOption) => {
    setUserRoleName(selectedOption);
    setFormValues({
      ...formValues,
      roleId: selectedOption ? selectedOption.value : ""
    });
    setFormErrors({
      ...formErrors,
      roleId: !selectedOption ? ValidateMessages?.REQUIRED("user role") : ""
    });
  };

  const handleUserReportingChange = (selectedOption) => {
    setUserReportingName(selectedOption);
    setFormValues({
      ...formValues,
      reportingTo: selectedOption.value,
    });
    setFormErrors({
      ...formErrors,
      reportingTo: !selectedOption
    });
  }

  const handleFormSubmit = useCallback(async (event) => {
    event.preventDefault();
    setIsSubmiting(false);
    setFormErrors(Validation(formValues));
    setIsSubmit(true);
  }, [formValues]);

  const handleFormChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
      const errors = Validation({ ...formValues, [name]: value });
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: errors[name],
      }));
    },
    [formValues]);

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      GetOne("userprofile", { id: item?.id }, setListData)
    }
  }, [location?.state]);

  useEffect(() => {
    if (editUserDetails) {
      setFormValues({
        ...formValues,
        userName: editUserDetails?.userName,
        userType: editUserDetails?.userType,
        firstName: editUserDetails?.firstName,
        lastName: editUserDetails?.lastName,
        userCompanyId: editUserDetails?.userCompanyId,
        phone: editUserDetails?.phone,
        designationId: editUserDetails?.designationId,
        departmentId: editUserDetails?.departmentId,
        password: editUserDetails?.password,
        confirmPassword: editUserDetails?.password,
        roleId: editUserDetails?.roleId,
        reportingTo: editUserDetails?.reportingTo,
        profileImage: editUserDetails?.profileImage,
        specialPermissions: editUserDetails?.specialPermissions,
        createdBy: editUserDetails?.createdBy,
        id: editUserDetails?.id,
        loginDisabled: editUserDetails?.loginDisabled,
        canViewCostingOverride: editUserDetails?.canViewCostingOverride,
        isActive: editUserDetails?.isActive
      })

      if (editUserDetails?.specialPermissions) {
        const userPermission = editUserDetails?.specialPermissions.split(",")
        setCheckedPermissions(userPermission)
      }
      const UserValue = userTypedrp.filter((item) => item.value === `${editUserDetails?.userType}`);
      if (UserValue && UserValue.length > 0) { setUserType(UserValue[0]) }

      setLoading(false);
    }
  }, [editUserDetails, userTypedrp])

  useEffect(() => {
    if (location?.state?.id && listdata?.data && Object.keys(listdata.data).length > 0) {
      const list = listdata?.data;
      const item = location?.state;
      const newItem = { row: { ...list, userName: item?.userName }, id: item?.id, userName: item?.userName };
      seteditUserDetails(newItem?.row);
    }
  }, [listdata]);

  const [errorShow, setErrorShow] = useState({ show: false, errorMessage: "" });
  const ErrorDoneClick = () => {
    setErrorShow({ show: false, errorMessage: "" })
    setCreateMsg(null);
  }
  const SuccessDoneClick = () => {
    setShow(false);
    navigate("/user-master")
  };

  useEffect(() => {
    const submitForm = async () => {
        if (Object.keys(formErrors).length === 0 && isSubmit) {
          const {
            id,
            userName,
            userType,
            userCompanyId,
            firstName,
            lastName,
            phone,
            designationId,
            departmentId,
            password,
            roleId,
            reportingTo,
            profileImage,
            specialPermissions,
            createdBy,
            loginDisabled,
            canViewCostingOverride,
            isActive
          } = formValues;

          const formRegister = {
            userName,
            password,
            firstName,
            lastName,
            userType,
            userCompanyId,
            phone,
            designationId,
            departmentId,
            createdBy,
            roleId,
            reportingTo,
            canViewCostingOverride,
            specialPermissions,
          };

          const formData = {
            userType,
            userCompanyId,
            firstName,
            lastName,
            phone,
            designationId,
            departmentId,
            specialPermissions,
            roleId,
            reportingTo,
            profileImage,
            createdBy,
            id,
            loginDisabled,
            canViewCostingOverride,
            isActive
          };

          if (formValues?.id) {
            UpdateEntry("userprofile", formData, setCreateMsg, SuccessMessages?.UPDATED("User"), ErrorMessages?.UPDATE_ERROR("User"));
            setIsSubmiting(true)
          }
          else {
            RegistrationEntry("registration", formRegister, setCreateMsg, SuccessMessages?.CREATED("Registration"), ErrorMessages?.UPDATE_ERROR("Registration"));
            setIsSubmiting(true)
          }
        }
    };
    submitForm();
  }, [formErrors, formValues, isSubmit]);

  const clearFormValues = () => {
    setFormValues({});
    navigate("/user-master")
  }

  useEffect(() => {
    if (CheckNull(createMsg?.message) === "Faliure") {
      setErrorShow(
        {
          show: true,
          errorMessage: createMsg.successData
        })
      setIsSubmit(false);
      setIsSubmiting(false);
    }
    else if (CheckNull(createMsg?.message) !== "") {
      setShow(true)
    }
  }, [createMsg])

  return {
    formValues,
    formErrors,
    handleFormSubmit,
    handleFormChange,
    show,
    setShow,
    createMsg,
    clearFormValues,
    handleUserTypeChange,
    handleCostingPermission,
    userType,
    handleCompanyChange,
    companyName,
    setCompanyName,
    handleDepartmentChange,
    departmentName,
    setDepartmentName,
    handleDesignationChange,
    designationName,
    setDesignationName,
    handleUserRoleChange,
    UserRoleName,
    handleUserReportingChange,
    UserReportingName,
    setUserRoleName,
    setUserReportingName,
    setUserType,
    errorShow,
    setErrorShow,
    ErrorDoneClick,
    handlePermissionType,
    checkedPermissions,
    setCheckedPermissions,
    userTypedrp,
    SuccessDoneClick,
    handleToggleChange,
    isChecked,
    setUserRoleName,
    setFormValues,
    isSubmit,
    isSubmiting,
    setFormErrors,
    loading

  }
}
export default useForm